import { useState, useEffect, useContext } from 'react'
import { Box, Container, Grid, Typography, Paper, Link, Divider, Chip, IconButton, Card, CardContent } from '@mui/material'
import { Schedule, Person, CalendarToday, AccessTime, LocationOn, VideoCall } from '@mui/icons-material'
import LoadingScreen from './LoadingScreen'
import AuthContext from './AuthContext'
import dayjs from 'dayjs'
const axios = require('axios').default

const BookingsScreen = (props) => {
  const { share } = useContext(AuthContext)
  const [loadingScreen, setLoadingScreen] = useState(true)
  const [bookings, setBookings] = useState([])

  const getBookings = () => {
    setLoadingScreen(true)
    axios.post('https://hlpscbffug.execute-api.us-west-2.amazonaws.com/prod/bookings/list',
      { token: props.token }
    )
    .then(res => {
      setLoadingScreen(false)
      if (res.data && res.data.bookings) {
        setBookings(res.data.bookings)
      }
    })
    .catch(err => {
      setLoadingScreen(false)
      console.error('Error fetching bookings:', err)
    })
  }

  const formatDateTime = (dateString) => {
    return dayjs(dateString).format('MMM DD, YYYY h:mm A')
  }

  const getLocationDisplay = (booking) => {
    // Check for video link first
    if (booking.body?.videoLink) {
      return (
        <Link href={booking.body.videoLink} target="_blank" rel="noopener">
          <VideoCall style={{ marginRight: 5, verticalAlign: 'middle' }} />
          Video Call
        </Link>
      )
    }

    // Then check for location
    if (booking.body?.location) {
      if (booking.body.location.startsWith('http')) {
        return (
          <Link href={booking.body.location} target="_blank" rel="noopener">
            <VideoCall style={{ marginRight: 5, verticalAlign: 'middle' }} />
            Video Call
          </Link>
        )
      }
      return (
        <>
          <LocationOn style={{ marginRight: 5, verticalAlign: 'middle' }} />
          {booking.body.location}
        </>
      )
    }

    // Check for address as fallback
    if (booking.body?.address && booking.body.address.trim()) {
      return (
        <>
          <LocationOn style={{ marginRight: 5, verticalAlign: 'middle' }} />
          {booking.body.address}
        </>
      )
    }

    return 'No location specified'
  }

  useEffect(() => {
    getBookings()
  }, [])

  return (
    <Box>
      <LoadingScreen open={loadingScreen} />
      {!loadingScreen && (
        <Container style={{ marginBottom: 20 }}>
          <Typography variant='h5' style={{ marginTop: 20, flexDirection: 'row', alignItems: 'center', display: 'flex' }} gutterBottom>
            <Schedule style={{ marginRight: 10 }} /> Bookings
          </Typography>
          <Typography variant='caption' style={{ marginTop: 10, flexDirection: 'row', alignItems: 'center', display: 'flex' }} gutterBottom>
            View all your scheduled meetings and bookings.
          </Typography>

          <Grid container spacing={3} style={{ marginTop: 20 }}>
            {bookings.length === 0 ? (
              <Grid item xs={12}>
                <Paper style={{ padding: 20, textAlign: 'center' }}>
                  <Typography variant="body1" color="textSecondary">
                    No bookings found.
                  </Typography>
                </Paper>
              </Grid>
            ) : (
              bookings.map((booking, index) => (
                <Grid item xs={12} key={booking.id || index}>
                  <Card elevation={2}>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={8}>
                          <Typography variant="h6" gutterBottom>
                            {booking.event?.name || booking.body?.eventName || 'Meeting'}
                          </Typography>

                          <Box display="flex" alignItems="center" marginBottom={1}>
                            <Person style={{ marginRight: 10, color: '#666' }} />
                            <Typography variant="body2">
                              {booking.body?.name || `${booking.body?.firstName || ''} ${booking.body?.lastName || ''}`.trim() || 'Unknown'}
                              {booking.body?.email && (
                                <Typography variant="caption" color="textSecondary" component="span">
                                  {' '}({booking.body.email})
                                </Typography>
                              )}
                            </Typography>
                          </Box>

                          <Box display="flex" alignItems="center" marginBottom={1}>
                            <CalendarToday style={{ marginRight: 10, color: '#666' }} />
                            <Typography variant="body2">
                              {(booking.body?.startDate || booking.body?.start) ? formatDateTime(booking.body.startDate || booking.body.start) : 'Date not specified'}
                            </Typography>
                          </Box>

                          {booking.body?.duration && (
                            <Box display="flex" alignItems="center" marginBottom={1}>
                              <AccessTime style={{ marginRight: 10, color: '#666' }} />
                              <Typography variant="body2">
                                {booking.body.duration} minutes
                              </Typography>
                            </Box>
                          )}

                          <Box display="flex" alignItems="center" marginBottom={1}>
                            <Typography variant="body2">
                              {getLocationDisplay(booking)}
                            </Typography>
                          </Box>

                          {booking.body?.agenda && (
                            <Box marginTop={2}>
                              <Typography variant="body2" color="textSecondary">
                                Agenda: {booking.body.agenda}
                              </Typography>
                            </Box>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={4} style={{ textAlign: 'right' }}>
                          {booking.body?.paid !== undefined && (
                            <Chip
                              label={booking.body.paid ? 'Paid' : 'Unpaid'}
                              color={booking.body.paid ? 'success' : 'default'}
                              size="small"
                              style={{ marginBottom: 10 }}
                            />
                          )}

                          {booking.body?.paymentAmount && (
                            <Typography variant="h6" color="primary">
                              ${booking.body.paymentAmount}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </Container>
      )}
    </Box>
  )
}

export default BookingsScreen